import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { fmtErr } from "../../lib/api";
import { useAuth, isStaff } from "../../context/AuthContext";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        setUser(data);
        toast.success(`Welcome, ${data.name}!`);
        navigate(isStaff(data) ? "/staff" : "/portal", { replace: true, state: { user: data } });
      } catch (e) {
        toast.error(fmtErr(e));
        navigate("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F2FBFB]">
      <div className="animate-pulse font-display font-bold text-[#0E7C84] text-xl" data-testid="auth-callback-loading">
        Signing you in with Google…
      </div>
    </div>
  );
}
